import { z } from 'zod'

import { accountSchema } from '~/components/smart-accounts/schemas/accountSchema'
import { amountSchema } from '~/components/smart-accounts/schemas/amountSchema'

const receiverSchema = z.object({
  // A blank field is "not provided", not invalid — `''` must not error as
  // "Invalid address". Presence is enforced by the form's submit gating.
  address: accountSchema.optional().or(z.literal('')),
  compliantPaymentRelationId: z.string().optional(),
})

export const recipientSchema = z.object({
  receiver: receiverSchema,
  amount: amountSchema,
  usdAmount: z.string().optional(),
})

export type RecipientFormValues = z.input<typeof recipientSchema>
